import Api from '@/api';
import { Http } from '../../../utilities/util';

const loadCompany = (context, companyId) => new Promise((resolve, reject) => {
  Api.companyService.getCompany(companyId)
    .then(response => {
      context.commit('setCompany', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setCompany', {});
      const httpError = Http.createError(
        error,
        'company.actions.loadCompany',
        { companyId },
      );
      Http.setGlobalError(context, httpError);
      reject();
    });
});

const loadCompanyAddtionalChargesSetting = (context, { companyId, settingKey }) => new Promise(
  (resolve, reject) => {
    Api.companyService.getCompanySetting(companyId, settingKey)
      .then(response => {
        context.commit('setCompanyAdditionalChargesSetting', response.data);
        resolve(response.data);
      })
      .catch(error => {
        context.commit('setCompanyAdditionalChargesSetting', {});
        const httpError = Http.createError(
          error,
          'company.actions.loadCompanySetting',
          { companyId },
        );
        Http.setGlobalError(context, httpError);
        reject();
      });
  },
);

const loadCompanyAddtionalChargesSettingEnabled
  = (context, { companyId, settingKey }) => new Promise(
    (resolve, reject) => {
      Api.companyService.getCompanySetting(companyId, settingKey)
        .then(response => {
          context.commit('setCompanyAdditionalChargesSettingEnabled', response.data);
          resolve(response.data);
        })
        .catch(error => {
          context.commit('setCompanyAdditionalChargesSettingEnabled', false);
          const httpError = Http.createError(
            error,
            'company.actions.loadCompanySetting',
            { companyId },
          );
          Http.setGlobalError(context, httpError);
          reject();
        });
    },
  );

export default {
  loadCompany,
  loadCompanyAddtionalChargesSetting,
  loadCompanyAddtionalChargesSettingEnabled,
};
